/**
 * Translate "6 months", or "5 years" into time in seconds
 */

/**  Environment  */
import environmentVariables from '../util/environmentVariables';
environmentVariables();

/**  Interfaces  */
interface IToolboxParseDateIntervalDictionary {
    [interval: string]: number;
}

/**
 * @returns {Number} Time interval in SECONDS
 */
export default function parseDateInterval(interval: string): number {
    /**
     * 1: Prep interval strings
     */
    const strings: IToolboxParseDateIntervalDictionary = {
        second: 1,
        minute: 60,
        hour: 60 * 60,
        day: 24 * 60 * 60,
        week: 7 * 24 * 60 * 60,
        month: 30 * 24 * 60 * 60,
        year: 365 * 24 * 60 * 60,
    };
    for (const k in strings) {
        strings[k + 's'] = strings[k];
    }

    /**
     * 2: Parse interval
     */
    let n, t;

    const words = interval.trim().split(' ');
    for (let i = 0; i < words.length; i++) {
        if (!words[i]) {
            continue;
        }

        if (!n && !isNaN((words[i] as unknown) as number)) {
            n = parseFloat(words[i]);
        } else if (!t && isNaN((words[i] as unknown) as number) && strings[words[i]]) {
            t = words[i];
        }
    }

    if ((!n && n !== 0) || !t) {
        throw new Error(`invalid date interval: "${interval}" is an invalid format`);
    }

    /**
     * 3: Return time in seconds
     */
    return n * strings[t];
}
